// 9fbef606107a605d69c0edbcd8029e5d
import constants, { crossBrands, crossBrandedKeys } from '../constants';

const buildQuery = ({ brand, country, channel }) => `
siteConfiguration(brand: "${brand}", country: "${country}", channel: "${channel}", crossBrandedKeys: ${JSON.stringify(
  crossBrandedKeys
)}, crossBrands: ${JSON.stringify(crossBrands)}) {
  crossSiteConfig
  sameSiteConfig
  errorMessage
}
`;

export default {
  getQuery: (data) => {
    return {
      query: buildQuery(data),
      cacheTag: constants.TYPE_SITE_CONFIG,
    };
  },
};
